//@ts-nocheck
// This file is the entry for Webpack and Parcel fallback.

import { getRoute } from "./get-route";
import { init } from "./init";
import { init as initRelay } from "./init-relay";

const { Component, isRelayEnabled, query, queryVars, relayApi } = getRoute(
    window.location
);
if (!isRelayEnabled) {
    init(Component);
} else {
    initRelay(Component, query, queryVars, relayApi);
}
